/**
 * The bundled catalogs (TMMAPP-0001), one namespace. Its own module so Vitest can alias it to the
 * en-only `tests/i18n/resources.ts` (TMMAPP-0135); the app always loads all four from here.
 */
import en from '@/locales/en.json';
import es from '@/locales/es.json';
import fr from '@/locales/fr.json';
import pt from '@/locales/pt.json';

export const RESOURCES = {
  en: { translation: en },
  es: { translation: es },
  fr: { translation: fr },
  pt: { translation: pt },
} as const;
